var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('message.navigation.contact.title'))+" ")])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('contact-export-card')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }